import {AuthenticationMethod as OutputAuthenticationMethod} from '@shared/models/signrequest/authentication/authentication-method';
import {AuthenticationMethod as InputAuthenticationMethod} from '@shared/models/document/authentication/authentication.method';
import {Smstan} from '@shared/models/signrequest/authentication/smstan';
import {SmsTan} from '@shared/models/document/authentication/sms.tan';
import {Injectable} from '@angular/core';
import {Sso} from '@shared/models/signrequest/authentication/sso';
import {Mouse} from '@shared/models/signrequest/authentication/mouse';
import {Idin} from '@shared/models/signrequest/authentication/idin';
import {Idin as IdinDTO} from '@shared/models/document/authentication/idin';
import {Irma} from '@shared/models/signrequest/authentication/irma';
import {Irma as IrmaDTO} from '@shared/models/document/authentication/irma';
import {Csc} from '@shared/models/signrequest/authentication/csc';
import {Csc as CscDTO} from '@shared/models/document/authentication/csc';
import {AmDocumentanchor} from '@shared/models/signrequest/authentication/documentanchor';
import {AmDocumentTemplate} from '@shared/models/signrequest/authentication/document-template';
import {CheckedID} from '@shared/models/signrequest/authentication/checkedid';
import {Checkedid} from '@shared/models/document/authentication/checkedid';


type InputToOutputParentFactory = (input: InputAuthenticationMethod) => OutputAuthenticationMethod;

@Injectable({
    providedIn: 'root'
})
export class AuthenticationMapper {

    private readonly inputToOutputByDiscriminatorFactory: Record<string, InputToOutputParentFactory> = {
        SMSTAN : (input) => {
            const output = new Smstan();
            output.authtype = input.authType;
            output.type = 'smstan';
            output.ordernumber = input.ordernumber;
            output.mobilePhone = (input as SmsTan).mobilePhone
            return output;
        },
        SSO: (input) => {
            const output = new Sso();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            return output;
        },
        MOUSE: (input) => {
            const output = new Mouse();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            return output;
        },
        IDIN: (input) => {
            const output = new Idin();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            output.dateofbirth = (input as IdinDTO).dateofbirth ? this.toDate((input as IdinDTO).dateofbirth) : undefined;
            output.initials = (input as IdinDTO).initials;
            output.legalLastname = (input as IdinDTO).legalLastname;
            output.legalLastnamePrefix = (input as IdinDTO).legalLastnamePrefix;
            output.city = (input as IdinDTO).city;
            output.email = (input as IdinDTO).email;
            output.houseno = (input as IdinDTO).houseno;
            output.phoneNumber = (input as IdinDTO).phoneNumber;
            output.housenosuf = (input as IdinDTO).housenosuf;
            output.postalcode = (input as IdinDTO).postalcode;
            return output;
        },
        IRMA: (input) => {
            const output = new Irma();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            output.dateofbirth = (input as IrmaDTO).dateOfBirth ? this.toDate((input as IrmaDTO).dateOfBirth) : undefined;
            output.initials = (input as IrmaDTO).initials;
            output.surname = (input as IrmaDTO).surname;
            return output;
        },
        CSC: (input) => {
            const output = new Csc();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            output.surName = (input as CscDTO).surName;
            output.birthDate = (input as CscDTO).birthDate;
            output.givenName = (input as CscDTO).givenName;
            output.allowedCSCProviders = (input as CscDTO).allowedCSCProviders;
            output.visualSignatureRequired = (input as CscDTO).visualSignatureRequired;
            return output;
        },
        DOCUMENT_ANCHORS: (input) => {
            const output = new AmDocumentanchor();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            return output;
        },
        DOCUMENT_TEMPLATE: (input) => {
            const output = new AmDocumentTemplate();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            return output;
        },
        CHECKEDID: (input) => {
            const output = new CheckedID();
            output.authtype = input.authType;
            output.ordernumber = input.ordernumber;
            output.hideBsn = (input as Checkedid).hideBsn;
            return output;
        }
    }


    private toDate = (s: string) => {
        const [dd, mm, yyyy] = s.split('-').map(Number);
        return new Date(yyyy, mm - 1, dd);
    };


    mapInputToOutput(input: InputAuthenticationMethod): OutputAuthenticationMethod | null {
        const factory = this.inputToOutputByDiscriminatorFactory[input.authenticationMethods];
        return factory ? factory(input) : null;
    }

    mapListInputToOutput(input: InputAuthenticationMethod[]): OutputAuthenticationMethod[] {
        const output: OutputAuthenticationMethod[] = [];
        for (const item of input) {
            const outputItem = this.mapInputToOutput(item);
            if (outputItem) output.push(outputItem);
        }
        return output;
    }
}
